import {Image, UnstyledButton} from "@mantine/core";
import React from "react";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import {IEBookDTO} from "@/form/publication";


interface IProps {
    item: IEBookDTO;
}

const EBookItem: React.FC<IProps> = ( { item } ) => {
    const { fontSize } = useGlobalStateStore();

    return (
        <UnstyledButton component="a" target="_blank" href={item.linkUrl} className={"group"}>
            <div className="flex flex-col group relative py-[20px] border-b border-[#d7d7d7]">
                <div className="text-[#8d7f4c] text-[14px] font-bold flex gap-3">{ item.fields.map(f => <div>{f}</div>) }</div>
                <div className="text-[#158a83] text-[26px] font-bold group-hover:text-black transition">{item.title}</div>
                <div className="text-[#999] text-[14px] my-[6px] tracking-wide">出版日期:{item.publishDateString}</div>
                <div className="text-[#333] text-[17px] text-justify line-clamp-2">{item.summary}</div>

            </div>
        </UnstyledButton>
    );
}


export default EBookItem;
